import axios from 'axios';
import i18next from 'i18next';
import { PAIDIT_API } from '../config';
import store from '../store';

const getConfig = () => {
    const { auth } = store.getState();

    const timezone = 'Asia/Jerusalem';

    return {
        baseURL: PAIDIT_API,
        timeout: 60000,
        headers: {
            authorization: auth.token,
            timezone,
            language: i18next.language
        }
    };
};

export default {
    post: (uri, data, config = getConfig()) => axios.post(uri, data, config),
    put: (uri, data, config = getConfig()) => axios.put(uri, data, config),
    get: (uri, config = getConfig()) => axios.get(uri, config),
    delete: (uri, config = getConfig()) => axios.delete(uri, config),
};
